import {
    RESETPAGINATION,
    ALLGROUPAGENTS,
    ACTIVEPERIODS,
    SERVICECOMBO,
    PRODUCTCOMBO,
    FACTORCOMBO,
    PRICESUPERVISOR,
    PRICEPRODUCT,
    PRICESERVICE,
    PRICEFACTOR,
    PRICEPERIOD,
    GETAGAINPRICESUPERVISOR,
    GETAGAINPRICESERVICE,
    GETAGAINPRICEPRODUCT,
    GETAGAINPRICEFACTOR,
    GETAGAINPRICEPERIOD,
    ACCALLGROUP,
    ACCFINANCIAL,
    ACCHISTORYINCTIME,
    DEFAULTPANEL,
    GETAGAINDEFAULTPANEL,
    DEFAULTCHARGE,
    GETAGAINDEFAULTCHARGE,
    CREDITTYPE,
    CREDITMETHOD,
    MANUALCREDIT,
    DISCOUNTCARD,
    GETAGAINDISCOUNTCARD,
    DISCOUNTCARDREFRENCE,
    DISCOUNTCARDSTYPE,
  } from "Stores/actionTypes";
  import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
  import StatusHandler from "Helpers/StatusHandler";
import addNumToList from "Helpers/addNumToList";

export const resetPagination = () => {
    return (dispatch) => {
        dispatch({
            type: RESETPAGINATION,
        });
    }
}

export const getAccountGroupAgent = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountGroupAgent(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: ALLGROUPAGENTS,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingPriceSupervisor = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountingPriceSupervisor(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: PRICESUPERVISOR,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingPriceSupervisorAgain = () => {
    return (dispatch) => {
        dispatch({
            type: GETAGAINPRICESUPERVISOR,
        });
    }
}

export const getActivePeriods = (params) => {
    return async (dispatch) => {
        try {
            const response = await AccountService.getActivePeriods(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: ACTIVEPERIODS,
                    data: response.data.Value,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getServiceCombo = (params) => {
    return async (dispatch) => {
        try {
            const response = await AccountService.getServiceCombo(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: SERVICECOMBO,
                    data: response.data.Value,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingPriceService = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountingPriceService(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: PRICESERVICE,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingPriceServiceAgain = () => {
    return (dispatch) => {
        dispatch({
            type: GETAGAINPRICESERVICE,
        });
    }
}

export const getProductCombo = (params) => {
    return async (dispatch) => {
        try {
            const response = await AccountService.getProductCombo(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: PRODUCTCOMBO,
                    data: response.data.Value,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingPriceProduct = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountingPriceProduct(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: PRICEPRODUCT,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingPriceProductAgain = () => {
    return (dispatch) => {
        dispatch({
            type: GETAGAINPRICEPRODUCT,
        });
    }
}

export const getAccountingDiscountCardStype = (params) => {
    return async (dispatch) => {
        try {
            const response = await AccountService.getAccountingDiscountCardStype(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: DISCOUNTCARDSTYPE,
                    data: response.data.Value,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingDiscountCardRefrence = (params) => {
    return async (dispatch) => {
        try {
            const response = await AccountService.getAccountingDiscountCardRefrence(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: DISCOUNTCARDREFRENCE,
                    data: response.data.Value,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getFactorCombo = (params) => {
    return async (dispatch) => {
        try {
            const response = await AccountService.getFactorCombo(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: FACTORCOMBO,
                    data: response.data.Value,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}
export const getAccountingPriceFactor = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountingPriceFactor(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: PRICEFACTOR,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingPriceFactorAgain = () => {
    return (dispatch) => {
        dispatch({
            type: GETAGAINPRICEFACTOR,
        });
    }
}

export const getAccountingPricePeriod = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountingPricePeriod(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: PRICEPERIOD,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingPricePeriodAgain = () => {
    return (dispatch) => {
        dispatch({
            type: GETAGAINPRICEPERIOD,
        });
    }
}

export const getAccountsAllGroup = (params) => {
    return async (dispatch) => {
        try {
            const response = await AccountService.getAccountsAllGroup(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: ACCALLGROUP,
                    data: response.data.Value,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingFinancial = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountingFinancial(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: ACCFINANCIAL,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const clearAccountingFinancial = () => {
    return async (dispatch) => {
        dispatch({
            type: ACCFINANCIAL,
            data: [],
            pagination: { Limit: 0, Page: 0, Total: 0 },
        });
    };
}

export const getAccountingFinancialExport = (params, document) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountingFinancialExport(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                const href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + response.data.Value;
                // window.open(href, "Download");
                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", `Financial Export (${params.Date.replaceAll('/','').replaceAll(' ','')})`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingHistoryIncTime = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountingHistoryIncTime(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: ACCHISTORYINCTIME,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const clearAccountingHistoryIncTime = () => {
    return async (dispatch) => {
        dispatch({
            type: ACCHISTORYINCTIME,
            data: [],
            pagination: { Limit: 0, Page: 0, Total: 0 },
        });
    };
}

export const getAccountingDefaultPanel = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountingDefaultPanel(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: DEFAULTPANEL,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingDefaultPanelAgain = () => {
    return (dispatch) => {
        dispatch({
            type: GETAGAINDEFAULTPANEL,
        });
    }
}

export const getAccountingDefaultCharge = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            params.IsAdminP = true;
            const response = await AccountService.getAccountingDefaultCharge(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: DEFAULTCHARGE,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingDefaultChargeAgain = () => {
    return (dispatch) => {
        dispatch({
            type: GETAGAINDEFAULTCHARGE,
        });
    }
}

export const getAccountingDManualCreditMethod = (params) => {
    return async (dispatch) => {
        try {
            const response = await AccountService.getAccountingDManualCreditMethod(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: CREDITMETHOD,
                    data: response.data.Value,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingDManualCreditType = (params) => {
    return async (dispatch) => {
        try {
            const response = await AccountService.getAccountingDManualCreditType(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: CREDITTYPE,
                    data: response.data.Value,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingManualCredit = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountingManualCredit(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: MANUALCREDIT,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingDiscountCard = (params) => {
    return async (dispatch) => {
        try {
            resetPagination();
            const response = await AccountService.getAccountingDiscountCard(params);
            let err = StatusHandler(response);
            if (!err.isFail) {
                dispatch({
                    type: DISCOUNTCARD,
                    data: addNumToList(response.data.Value, params.Page, params.Limit),
                    pagination: response.data.Pagination,
                });
            }
        } catch (err) {
      console.error('[catch error]', err)
    }
    };
}

export const getAccountingDiscountCardAgain = () => {
    return (dispatch) => {
        dispatch({
            type: GETAGAINDISCOUNTCARD,
        });
    }
}
